import { Platform } from 'react-native';
import Colors from '../../config/Colors';
import Layout from '../../config/Layout';

export default {
    container: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'absolute',
        width: '100%',
        alignItems: 'center',
        alignSelf: 'center',
        top: Platform.OS !== 'web' ? (Platform.OS === 'ios' ? 78 : 62) : 16,
        zIndex: 9999,
        pointerEvents: 'none'
    },
    content: {
        backgroundColor: Colors.dark,
        paddingHorizontal: Layout.gutterLarge,
        paddingVertical: Platform.OS !== 'web' ? 16 : 12,
        borderRadius: Layout.radius,
        justifyContent: 'space-between',
        alignItems: 'center',
        flexDirection: 'row',

        marginBottom: Platform.OS !== 'web' ? null : 4
    },
    label: {
        flex: 2,
        fontSize: 16
    },
    success: {
        backgroundColor: Colors.success
    },
    successText: {
        color: Colors.white
    },
    error: {
        backgroundColor: Colors.danger
    },
    errorText: {
        color: Colors.white
    }
};
